import { useEffect } from "react";
import { FilterControls, type FilterControlsProps } from "./FilterPanel";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "./ui/sheet";

interface MobileFilterSheetProps extends FilterControlsProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function MobileFilterSheet({ open, onOpenChange, ...filterProps }: MobileFilterSheetProps) {
  useEffect(() => {
    if (!open || typeof window.matchMedia !== "function") return undefined;
    const desktopQuery = window.matchMedia("(min-width: 1024px)");
    const closeAtDesktop = (event: MediaQueryListEvent) => {
      if (event.matches) onOpenChange(false);
    };

    if (desktopQuery.matches) {
      onOpenChange(false);
      return undefined;
    }

    desktopQuery.addEventListener("change", closeAtDesktop);
    return () => desktopQuery.removeEventListener("change", closeAtDesktop);
  }, [onOpenChange, open]);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="max-w-md overflow-y-auto lg:hidden">
        <SheetHeader>
          <SheetTitle>Filters</SheetTitle>
          <SheetDescription>
            Refine the same URL-backed screener state used by the desktop panel.
          </SheetDescription>
        </SheetHeader>
        <div className="p-4">
          <FilterControls {...filterProps} advancedPresentation="inline" />
        </div>
      </SheetContent>
    </Sheet>
  );
}
